import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { ModalOverlayRef, ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'serviceos-web-invite-social-modal',
    templateUrl: './invite-social-modal.component.html',
    styleUrls: ['./invite-social-modal.component.scss'],
})
export class InviteSocialModalComponent {
  
    @Select(
        ModulesSelectors.getComponentFromModule('account', 'social_referrals')
    )
    referral_social$!: Observable<any>;

    constructor(public modalRef: ModalOverlayRef,) { }

    public onSocialEvent(eventObject: any): void {
        if (this.modalRef.configData && this.modalRef.configData.callback && typeof this.modalRef.configData.callback === 'function') {
            this.modalRef.configData.callback(eventObject);
        }
    }
}
